import { render } from "./PageRibbon.vue?vue&type=template&id=2751d30b&scoped=true"
import script from "./PageRibbon.vue?vue&type=script&lang=js"
export * from "./PageRibbon.vue?vue&type=script&lang=js"

import "./PageRibbon.vue?vue&type=style&index=0&id=2751d30b&lang=scss&scoped=true"

import exportComponent from "/app/tmp/360pt/V3/v2026.31.r1/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2751d30b"]])

export default __exports__